import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';

interface DialogRenameProps {
  open: boolean;
  onClose: () => void;
  text?: string;
  onSave: (newText: string | undefined) => void;
}

export function DialogRename({
  open,
  onClose,
  text,
  onSave,
}: Readonly<DialogRenameProps>) {
  const [newText, setNewText] = useState(text);

  useEffect(() => {
    setNewText(text);
  }, [text]);

  const handleChange = (e: any) => {
    const { value } = e.target;
    setNewText(value);
  };

  const handleSave = () => {
    onSave(newText);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Rename</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Description"
          type="text"
          fullWidth
          multiline={true}
          value={newText}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
